// extracted by mini-css-extract-plugin
module.exports = {"page":"Homepage_page__10L56","hidden":"Homepage_hidden__gpj2u"};